export enum ModifierTypeEnum {
  NO_TYPE = 'no type',
  STANDARD = 'standard',
  NOTE = 'note',
}
